import React, {useEffect} from 'react';
import moment from 'moment';
import LineGraph from './LineGraph';

import { graphOrder } from 'utils/code';
import { classifyCriterionDataByModule } from 'utils/utils';

const LineGraphMain = (props) => {
  const createLineGraphComponent = graphOrder[props.moduleScn].map((key) => {
    const data = props.data.map((d) => {
      return key === 'o2' ? d[key]?.toFixed(1) ?? 0 : d[key];
    });

    return (
      <LineGraph
        key={key}
        graphId={key}
        data={data}
        moduleScn={props.moduleScn}
        moduleIdx={props.moduleIdx}
        categories={props.data.map((d) => {
          return moment(d.rgstDt).format('YYYY-MM-DD HH:mm:ss');
        })}
        criterion={classifyCriterionDataByModule(props.criterion[key], props.moduleIdx)}
        flag={props.flag}
      />
    );
  });

  return (
    <div className="graphMainPopup-lineGraph">
      <div className="wrapper">{createLineGraphComponent}</div>
    </div>
  );
};

export default LineGraphMain;
